import { Theme } from '../enum/Theme';
import React from 'react';
import { TouchableOpacity, Text, View, StyleSheet } from 'react-native';
import SpaceW from './SpaceW';

interface CardProps {
  titleTop?: string;
  title: string;
  number: string;
  subItems: { value: string; label: string; color?: string }[];
}

const MAX_BAR_HEIGHT = 200; // Altura máxima das barras

const Card: React.FC<CardProps> = ({
  titleTop,
  title,
  number,
  subItems,
}) => {
  const total = subItems.reduce((acc, item) => acc + parseInt(item.value), 0);

  return (
    <TouchableOpacity style={styles.card}>
      <View style={{ flexDirection: 'row' }}>
        <View>
          <View style={{ flex: 1 }}>
            {titleTop && <Text style={styles.cardTitleTop}>{titleTop}</Text>}
            <Text style={styles.cardTitle}>{title}</Text>
            <Text style={styles.cardNumber}>{number}</Text>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            {subItems.map((item, index) => (
              <View key={index} style={{ paddingRight: 20, flexDirection: 'row', alignItems: 'center' }}>
                <View style={[styles.colorDot, { backgroundColor: item.color || Theme.foreground }]} />
                <View style={{ alignItems: 'center' }}>
                  <Text style={styles.cardSub}>{item.value}</Text>
                  <Text style={styles.cardSub}>{item.label}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
        <SpaceW size={20} />
        <View style={{ minWidth: 70, alignItems: 'center' }}>
          <View style={{ backgroundColor: '#F0F0F0', height: 3, width: '100%' }} />
          <View style={styles.barContainer}>
            {subItems.map((item, index) => {
              const heightPercentage = total > 0 ? parseInt(item.value) / total : 0;
              const barHeight = heightPercentage * MAX_BAR_HEIGHT;
              return (
                <View
                  key={index}
                  style={[
                    styles.bar,
                    {
                      height: barHeight,
                      backgroundColor: item.color || Theme.foreground,
                      marginRight: 5,
                    },
                  ]}
                />
              );
            })}
          </View>
          <View style={{ backgroundColor: '#F0F0F0', height: 10, width: '100%' }} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    margin: 5,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 10,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 20,
    color: Theme.foreground,
  },
  cardTitleTop: {
    fontSize: 16,
    color: Theme.foreground,
  },
  cardNumber: {
    fontSize: 32,
    fontWeight: 'bold',
    color: Theme.foreground,
  },
  barContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    padding: 4,
  },
  bar: {
    width: 30,
  },
  cardSub: {
    textAlign: 'center',
    fontSize: 12,
    color: '#999',
  },
  colorDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginRight: 5,
  },
});

export default Card;
